class ArticleContainer {
  constructor(containerElem, articleElm = null, data = null, config = {}) {
    this.staticData = data
    this.config = config
    this._loaded = config.preLoaded
    this.containerElem = containerElem
    this.articleElem = articleElm || containerElem.querySelector('.caas-article')
    this.midpointAd = containerElem.querySelector('.midpoint-ad')
    this.commentsElem = containerElem.querySelector('.m-spotim')
    this.caasData = {}
    this.siteAttributes = {}
  }

  get data() {
    if (this.staticData) return this.staticData
    const { stateKey } = this.articleElem.dataset
    return wafer.base.state[stateKey]
  }

  get isLoaded() {
    if (this._loaded) return true
    this._loaded =
      this.articleElem?.classList.contains('wafer-caas-complete') ||
      this.articleElem?.querySelector('article')
    return this._loaded
  }

  get hasError() {
    return this.articleElem.classList.contains('wafer-caas-error')
  }

  get hasStateArticle() {
    if (!this.articleElem) return false
    const { stateKey } = this.articleElem.dataset
    return wafer?.base.state[stateKey]
  }

  get lmsid() {
    return this.siteAttributes?.rs?.lmsid || this.data.lmsid
  }

  get publisher() {
    return this.caasData?.publisher || this.data.publisher
  }

  get isInView() {
    const { elementInView } = window.NEXUtils
    return elementInView(this.containerElem)
  }

  get inViewPercentage() {
    if (!this.isInView) {
      return 0
    }
    const viewport = {
      top: 0,
      left: 0,
      bottom: window.innerHeight || document.documentElement.clientHeight,
      right: window.innerWidth || document.documentElement.clientWidth
    }

    const viewportArea = (viewport.bottom - viewport.top) * (viewport.right - viewport.left)
    const elem = this.containerElem.getBoundingClientRect()
    const visibleElem = {
      top: Math.max(elem.top, viewport.top),
      right: Math.min(elem.right, viewport.right),
      bottom: Math.min(elem.bottom, viewport.bottom),
      left: Math.max(elem.left, viewport.left)
    }
    const elemArea = (visibleElem.bottom - visibleElem.top) * (visibleElem.right - visibleElem.left)

    return (elemArea / viewportArea) * 100
  }

  setCaasData(data) {
    this.caasData = data
    this.siteAttributes = this._parseSiteAttributes(data)
    const { commentsAllowed } = data
    if (!commentsAllowed) {
      this.removeComments()
    }
  }

  validate() {
    const isValid = this.hasStateArticle
    if (!isValid) {
      this.destroy()
    }
    return isValid
  }

  moveAd() {
    if (!this.isLoaded || !this.midpointAd) return
    const articleParagraphs = [...this.containerElem.querySelectorAll('.caas-body > p')]
    const articleReadMorePos = [...this.containerElem.querySelectorAll('.caas-body .caas-readmore')]
    if (articleReadMorePos.length > 0) {
      this._move(this.midpointAd, articleReadMorePos, 0, true)
    } else {
      let midpoint = parseInt(articleParagraphs.length / 2 - 1, 10)
      // move the ad up one paragraph if the midpoint contains a strong tag, e.g. is a callout
      if (articleParagraphs[midpoint].querySelector('strong') && midpoint - 1 >= 0) {
        midpoint -= 1
      }
      this._move(this.midpointAd, articleParagraphs, midpoint)
    }
  }

  removeComments() {
    this.commentsElem?.parentElement.removeChild(this.commentsElem)
  }

  destroy() {
    this.containerElem.parentElement.removeChild(this.containerElem)
  }

  _move(elem, articleParagraphs, position, before) {
    if (!elem || !articleParagraphs || articleParagraphs.length <= position) {
      return
    }

    // If its an rmp module also move its wrapping divs
    const elmToMove = elem.closest('.maas-item') || elem
    articleParagraphs[position].insertAdjacentElement(
      before ? 'beforebegin' : 'afterend',
      elmToMove
    )
  }

  // This is a duplication of the code in td-app-aol here: https://git.ouryahoo.com/frontpage/td-app-aol/blob/eaae61b08ed646bc335f40f61922ee5b13450043/lib/contentUtils.js#L136-L198
  _parseSiteAttributes({ adMeta: { site_attribute: siteAttr = '' } = {} } = {}) {
    const spilt = (siteAttr.match(/([^=]*)=("[^"]*")/g) || []).filter(Boolean)

    return spilt.reduce((obj, kv) => {
      // eslint-disable-next-line prefer-const
      let [key = '', value = ''] = kv.split('=')

      try {
        // The value may be json encoded
        value = JSON.parse(value)
      } catch (e) {
        // Do nothing
      }

      const sanitizedKey = key.trim()
      const sanitizedValue = value.trim().split(';')
      obj[sanitizedKey] = sanitizedValue

      // rev share has an additional level of normalization
      if (sanitizedKey === 'rs') {
        // keep reference to the raw string, so we do not need to recreate it later
        obj.revshare = value
        obj[sanitizedKey] = obj[sanitizedKey].reduce((rsObj, rsKV) => {
          const [rsKey, rsValue] = rsKV.split(':')
          rsObj[rsKey] = rsValue
          return rsObj
        }, {})
      }

      return obj
    }, {})
  }
}

module.exports = { ArticleContainer }
